/* -----------------------------------------------------------------------
 * <copyright company="Microsoft Corporation">
 *   Copyright (c) Microsoft Corporation.  All rights reserved.
 * </copyright>
 * ----------------------------------------------------------------------- */

// <reference path="./OfficeBrowserFeedback.d.ts"/>

import { ActionType, EventName } from "@microsoftit/telemetry-extensions-npm";
import { Activity, SurveyLaunchFailed, SurveyTaken } from "../../Constants";

import campaigns from "./campaigns";
import { config } from "../config";
import { logTelemetry } from "../telemetry/telemetryWrapper";

class FloodgateService {
  public async init(): Promise<void> {
    const anyWindow = window as any;
    anyWindow.OfficeBrowserFeedback = anyWindow.OfficeBrowserFeedback || {};
    anyWindow.OfficeBrowserFeedback.floodgate = anyWindow.OfficeBrowserFeedback
      .floodgate || {
      initialize: () => {}, // eslint-disable-line @typescript-eslint/no-empty-function
      start: () => {}, // eslint-disable-line @typescript-eslint/no-empty-function
      getEngine: () => {
        return {
          getActivityListener: () => {
            return { logActivity: (str: string) => {} }; // eslint-disable-line
          },
        };
      },
    };
    anyWindow.OfficeBrowserFeedback.initOptions = {
      locale: "en-US",
      appId: Number(config.ocv.appId), 
      stylesUrl: `/static/styles/survey.css`,
      intlUrl: `/static/intl/`,
      intlFilename: "officebrowserfeedbackstrings.js",
      environment: config.production ? 0 : 1,
      userEmail: "",
      userEmailConsentDefault: false,
      sessionId: "",
      telemetryGroup: {
        featureArea: process.env.REACT_APP_OCV_SURVEY_CAMPAIGN_FEATUREAREA,
      },
      onError: (err: any) => {
        const logProperties = {
          error: err,
        };
        logTelemetry(
          "SubmitSurvey",
          "",
          ActionType.User,
          SurveyLaunchFailed,
          EventName.ButtonClick,
          logProperties
        );
      },
    };
    anyWindow.OfficeBrowserFeedback.floodgate.initOptions = {
      autoDismiss: 2, 
      campaignDefinitions: campaigns,
      onDismiss: (campaignId: string, submitted: boolean) => {
        if (submitted) {

          const logProperties = {
            submitted: submitted,
            campaignId: campaignId,
          };
          logTelemetry(
            "SubmitSurvey",
            "",
            ActionType.User,
            SurveyTaken,
            EventName.ButtonClick,
            logProperties
          );
        }
      },
    };

    await anyWindow.OfficeBrowserFeedback.floodgate.initialize();

    anyWindow.onfocus = () => {
      if ((window as any).OfficeBrowserFeedback.floodgate) {
        anyWindow.OfficeBrowserFeedback.floodgate.start();
      }
    };

    anyWindow.onblur = () => {
      if ((window as any).OfficeBrowserFeedback.floodgate) {
        anyWindow.OfficeBrowserFeedback.floodgate.stop();
      }
    };

    anyWindow.onunload = () => {
      if ((window as any).OfficeBrowserFeedback.floodgate) {
        anyWindow.OfficeBrowserFeedback.floodgate.stop();
      }
    };
  }

  public async startEngine() {
    await (window as any).OfficeBrowserFeedback.floodgate.start();
  }

  public async stopEngine() {
    await (window as any).OfficeBrowserFeedback.floodgate.stop();
  }
  
  public triggerRequestCompletedActivity() {
    (window as any).OfficeBrowserFeedback.floodgate
      .getEngine()
      .getActivityListener()
      .logActivity(Activity.RequestCompleted);
  }
}

export const floodgateService = new FloodgateService();
export default floodgateService;
